import React from 'react';
import PageState from './PageState';

/**
 * Last line of defence for a page that throws while rendering or fails to
 * load: shows a message with a reload button instead of a blank screen.
 * `resetKey` (e.g. the current path) clears the error when the user navigates.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, info) {
    // Keep the details in the console for debugging.
    console.error('Page failed to render', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const isLoadError = this.state.error?.name === 'ChunkLoadError';
    return (
      <PageState
        title={isLoadError ? "This page couldn't load" : 'Something went wrong'}
        description={
          isLoadError
            ? 'The app may have been updated, or the connection dropped. Trying again usually fixes it.'
            : 'Trying again usually fixes it. If it keeps happening, let an administrator know what you were doing.'
        }
      />
    );
  }
}

export default ErrorBoundary;
